<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">
    Table of Contents
  </div>
<div class="sgc-toc-level-1 sgc-1">
<a href="#/Text/preface">Preface</a>
</div>
<div class="sgc-toc-level-1 sgc-1">
<br/>
</div>
<div class="sgc-toc-level-1 sgc-1">
<a href="#/Text/Chap_01">1</a>
</div>
<div class="sgc-toc-level-1 sgc-1">
<a href="#/Text/Chap_01#toc-anchor-1">In Danger</a>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<a href="#/Text/Chap_02">2</a>
</div>
<div class="sgc-toc-level-1 sgc-1">
<a href="#/Text/Chap_02#toc-anchor-2">A Dawning Criminal</a>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<a href="#/Text/Chap_03">3</a>
</div>
<div class="sgc-toc-level-1 sgc-1">
<a href="#/Text/Chap_03#toc-anchor-3">In and Out</a>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<a href="#/Text/Chap_04">4</a>
</div>
<div class="sgc-toc-level-1 sgc-1">
<a href="#/Text/Chap_04#toc-anchor-4">The Matthew Enigma</a>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<a href="#/Text/Chap_05">5</a>
</div>
<div class="sgc-toc-level-1 sgc-1">
<a href="#/Text/Chap_05#toc-anchor-5">Criminal Minds</a>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<a href="#/Text/Chap_06">6</a>
</div>
<div class="sgc-toc-level-1 sgc-1">
<a href="#/Text/Chap_06#toc-anchor-6">Bobby</a>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_07" title="Link target outside of Sample">7</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_07#toc-anchor-7" title="Link target outside of Sample">Not So Ordinary</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_08" title="Link target outside of Sample">8</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_08#toc-anchor-8" title="Link target outside of Sample">Take a Swim</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_09" title="Link target outside of Sample">9</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_09#toc-anchor-9" title="Link target outside of Sample">The Signs</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_10" title="Link target outside of Sample">10</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_10#toc-anchor-10" title="Link target outside of Sample">An Ordinary Bird</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_11" title="Link target outside of Sample">11</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_11#toc-anchor-11" title="Link target outside of Sample">A Stash</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_12" title="Link target outside of Sample">12</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_12#toc-anchor-12" title="Link target outside of Sample">Preparations</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_13" title="Link target outside of Sample">13</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_13#toc-anchor-13" title="Link target outside of Sample">Aladdin’s Cave</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_14" title="Link target outside of Sample">14</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_14#toc-anchor-14" title="Link target outside of Sample">The Hoard</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_15" title="Link target outside of Sample">15</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_15#toc-anchor-15" title="Link target outside of Sample">The Little Thing</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_16" title="Link target outside of Sample">16</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_16#toc-anchor-16" title="Link target outside of Sample">The Victims</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_17" title="Link target outside of Sample">17</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_17#toc-anchor-17" title="Link target outside of Sample">Fulmer</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_18" title="Link target outside of Sample">18</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_18#toc-anchor-18" title="Link target outside of Sample">60 Minutes</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_19" title="Link target outside of Sample">19</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_19#toc-anchor-19" title="Link target outside of Sample">The Money</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_20" title="Link target outside of Sample">20</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_20#toc-anchor-20" title="Link target outside of Sample">The Turn</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_21" title="Link target outside of Sample">21</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_21#toc-anchor-21" title="Link target outside of Sample">Chasing Dollars</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_22" title="Link target outside of Sample">22</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_22#toc-anchor-22" title="Link target outside of Sample">The Break</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_23" title="Link target outside of Sample">23</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_23#toc-anchor-23" title="Link target outside of Sample">Chrysalis</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_24" title="Link target outside of Sample">24</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_24#toc-anchor-24" title="Link target outside of Sample">Tragedy</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_25" title="Link target outside of Sample">25</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_25#toc-anchor-25" title="Link target outside of Sample">The Plot</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_26" title="Link target outside of Sample">26</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_26#toc-anchor-26" title="Link target outside of Sample">Tail-Checks</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_27" title="Link target outside of Sample">27</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_27#toc-anchor-27" title="Link target outside of Sample">The Girls</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_28" title="Link target outside of Sample">28</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_28#toc-anchor-28" title="Link target outside of Sample">The Rec Yard</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_29" title="Link target outside of Sample">29</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_29#toc-anchor-29" title="Link target outside of Sample">Paint</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_30" title="Link target outside of Sample">30</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_30#toc-anchor-30" title="Link target outside of Sample">Loose Ends</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_31" title="Link target outside of Sample">31</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_31#toc-anchor-31" title="Link target outside of Sample">Sheep and Wolves</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_32" title="Link target outside of Sample">32</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_32#toc-anchor-32" title="Link target outside of Sample">The First Trial</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_33" title="Link target outside of Sample">33</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_33#toc-anchor-33" title="Link target outside of Sample">Paper Terrorism</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_34" title="Link target outside of Sample">34</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_34#toc-anchor-34" title="Link target outside of Sample">The Big Property Trial</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_35" title="Link target outside of Sample">35</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_35#toc-anchor-35" title="Link target outside of Sample">Following Through</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_36" title="Link target outside of Sample">36</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_36#toc-anchor-36" title="Link target outside of Sample">The Mind of Monroe</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_37" title="Link target outside of Sample">37</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_37#toc-anchor-37" title="Link target outside of Sample">The Big Guys</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_38" title="Link target outside of Sample">38</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_38#toc-anchor-38" title="Link target outside of Sample">Androgyny</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_39" title="Link target outside of Sample">39</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_39#toc-anchor-39" title="Link target outside of Sample">Bryan’s Trial</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_40" title="Link target outside of Sample">40</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_40#toc-anchor-40" title="Link target outside of Sample">Man Hunting</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_41" title="Link target outside of Sample">41</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_41#toc-anchor-41" title="Link target outside of Sample">Unpredictable</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_42" title="Link target outside of Sample">42</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_42#toc-anchor-42" title="Link target outside of Sample">Justice</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_43" title="Link target outside of Sample">43</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_43#toc-anchor-43" title="Link target outside of Sample">Buyer’s Remorse</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_44" title="Link target outside of Sample">44</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_44#toc-anchor-44" title="Link target outside of Sample">Bellagio</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_45" title="Link target outside of Sample">45</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_45#toc-anchor-45" title="Link target outside of Sample">STOP CORUPTION</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_46" title="Link target outside of Sample">46</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_46#toc-anchor-46" title="Link target outside of Sample">Exposed</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_47" title="Link target outside of Sample">47</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_47#toc-anchor-47" title="Link target outside of Sample">The Right Thing</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_48" title="Link target outside of Sample">48</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_48#toc-anchor-48" title="Link target outside of Sample">The Smoking Gun</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_49" title="Link target outside of Sample">49</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_49#toc-anchor-49" title="Link target outside of Sample">Convincing Science</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_50" title="Link target outside of Sample">50</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_50#toc-anchor-50" title="Link target outside of Sample">Distractions</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_51" title="Link target outside of Sample">51</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_51#toc-anchor-51" title="Link target outside of Sample">The Big Show</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_52" title="Link target outside of Sample">52</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_52#toc-anchor-52" title="Link target outside of Sample">The Good Guy</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_53" title="Link target outside of Sample">53</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_53#toc-anchor-53" title="Link target outside of Sample">Closing Arguments</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_54" title="Link target outside of Sample">54</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_54#toc-anchor-54" title="Link target outside of Sample">Verdicts</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_55" title="Link target outside of Sample">55</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_55#toc-anchor-55" title="Link target outside of Sample">Chicken on the Bone</span>
</div>
<div class="sgc-toc-level-1 sgc-1"><br/></div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_56" title="Link target outside of Sample">56</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Chap_56#toc-anchor-56" title="Link target outside of Sample">Poisoned Minds</span>
</div>
<div class="sgc-toc-level-1 sgc-1">
<br/>
</div>
<div class="sgc-toc-level-1 sgc-1">
<span href="#/Text/Ack" title="Link target outside of Sample">Acknowledgments</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?d29c2b96